/* mm extras: live search, quick view, recently viewed */
(function () {
  if (!window.fetch) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML.replace(/"/g, '&quot;'); }
  function money(v) { var n = Number(v); if (isNaN(n)) return ''; return 'LE ' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function cents(c) { return money(c / 100); }

  /* ---------- live search ---------- */
  function setup(input) {
    if (input.getAttribute('data-ls')) return;
    input.setAttribute('data-ls', '1');
    input.setAttribute('autocomplete', 'off');
    var box = document.createElement('div');
    box.className = 'ls';
    box.hidden = true;
    document.body.appendChild(box);
    var timer = null, ctl = null, last = '';
    function place() {
      var r = input.getBoundingClientRect();
      if (!r.height) { box.hidden = true; return; }
      box.style.top = (r.bottom + 6) + 'px';
      box.style.left = r.left + 'px';
      box.style.width = Math.max(r.width, 280) + 'px';
    }
    function hide() { box.hidden = true; }
    function render(q, items) {
      var all = '<a class="ls__all" href="' + root + 'search?type=product&q=' + encodeURIComponent(q) + '">See all results</a>';
      if (!items.length) { box.innerHTML = '<p class="ls__empty">No products found for &ldquo;' + esc(q) + '&rdquo;</p>'; }
      else {
        box.innerHTML = items.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image;
          var cmp = parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? '<s>' + money(p.compare_at_price_max) + '</s>' : '';
          return '<a class="ls__i" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48" loading="lazy">' : '<span class="ls__noimg"></span>') +
            '<span class="ls__t">' + esc(p.title) + '</span><span class="ls__p">' + money(p.price) + cmp + '</span></a>';
        }).join('') + all;
      }
      place();
      box.hidden = false;
    }
    function run(q) {
      if (ctl && ctl.abort) ctl.abort();
      ctl = window.AbortController ? new AbortController() : null;
      last = q;
      fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctl ? { signal: ctl.signal } : undefined)
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || q !== last) return;
          render(q, (j.resources && j.resources.results && j.resources.results.products) || []);
        })
        .catch(function () {});
    }
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { last = ''; hide(); return; }
      timer = setTimeout(function () { run(q); }, 220);
    });
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length > 1) { place(); box.hidden = false; } });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    document.addEventListener('click', function (e) { if (e.target !== input && !box.contains(e.target)) hide(); });
    window.addEventListener('resize', function () { if (!box.hidden) place(); });
    window.addEventListener('scroll', function () { if (!box.hidden) place(); }, { passive: true });
  }
  document.querySelectorAll('input[type="search"][name="q"]').forEach(setup);

  /* ---------- quick view ---------- */
  var modal, qbody, lastFocus;
  function size(u, w) { return String(u).replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2'); }
  function build() {
    modal = document.createElement('div');
    modal.className = 'qv';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML = '<div class="qv__ov" data-qv-close></div><div class="qv__box" role="dialog" aria-modal="true" aria-label="Quick view"><button type="button" class="qv__x" data-qv-close aria-label="Close">&times;</button><div class="qv__body"></div></div>';
    document.body.appendChild(modal);
    qbody = modal.querySelector('.qv__body');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-qv-close]')) { closeQv(); return; }
      var inp = qbody.querySelector('input[name="quantity"]');
      if (!inp) return;
      if (e.target.closest('[data-qv-minus]')) inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) - 1);
      if (e.target.closest('[data-qv-plus]')) inp.value = (parseInt(inp.value, 10) || 1) + 1;
    });
    modal.addEventListener('submit', function () { setTimeout(closeQv, 450); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeQv(); });
  }
  function closeQv() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function showQv(p) {
    var imgs = (p.images && p.images.length) ? p.images : (p.featured_image ? [p.featured_image] : []);
    var gal = imgs.length ? '<div class="qv__gal">' + imgs.slice(0, 6).map(function (u) { return '<img src="' + esc(size(u, 700)) + '" alt="" loading="lazy">'; }).join('') + '</div>' : '';
    var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var single = p.variants.length === 1;
    var first = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var sel = [first.option1, first.option2, first.option3];
    var opts = single ? '' : names.map(function (n, i) {
      var vals = [];
      p.variants.forEach(function (v) { var x = v['option' + (i + 1)]; if (x != null && vals.indexOf(x) < 0) vals.push(x); });
      return '<div class="opt"><p class="opt__label">' + esc(n) + '</p><div class="opt__pills">' + vals.map(function (x) {
        return '<label class="pill-opt"><input type="radio" name="qvo' + i + '" value="' + esc(x) + '"' + (sel[i] === x ? ' checked' : '') + '><span>' + esc(x) + '</span></label>';
      }).join('') + '</div></div>';
    }).join('');
    var desc = String(p.description || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (desc.length > 170) desc = desc.slice(0, 167) + '...';
    qbody.innerHTML = '<div>' + gal + '</div><div><h2 class="qv__t">' + esc(p.title) + '</h2><div class="qv__price" data-qv-price></div>' + (desc ? '<p class="qv__d">' + esc(desc) + '</p>' : '') +
      '<form class="qv__form" action="' + root + 'cart/add" method="post" data-qv-form><input type="hidden" name="id" value="" data-qv-id>' + opts +
      '<div class="qty"><button type="button" data-qv-minus aria-label="Decrease quantity">&minus;</button><input type="number" name="quantity" value="1" min="1" inputmode="numeric" aria-label="Quantity"><button type="button" data-qv-plus aria-label="Increase quantity">+</button></div>' +
      '<button class="btn atc" type="submit" data-qv-add>Add to cart</button></form><a class="qv__full" href="' + esc(p.url) + '">View full details</a></div>';
    var form = qbody.querySelector('[data-qv-form]');
    function pick() {
      var v;
      if (single) v = p.variants[0];
      else {
        var chosen = names.map(function (n, i) { var c = form.querySelector('input[name="qvo' + i + '"]:checked'); return c ? c.value : null; });
        v = p.variants.filter(function (x) { return chosen.every(function (c, i) { return c === null || x['option' + (i + 1)] === c; }); })[0];
      }
      var price = qbody.querySelector('[data-qv-price]'), add = qbody.querySelector('[data-qv-add]'), id = qbody.querySelector('[data-qv-id]');
      if (!v) { price.textContent = ''; id.value = ''; add.disabled = true; add.textContent = 'Unavailable'; return; }
      id.value = v.id;
      price.innerHTML = cents(v.price) + (v.compare_at_price > v.price ? '<s>' + cents(v.compare_at_price) + '</s>' : '');
      add.disabled = !v.available;
      add.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    form.addEventListener('change', pick);
    pick();
  }
  function openQv(handle, trigger) {
    if (!modal) build();
    lastFocus = trigger;
    qbody.innerHTML = '<p class="qv__load">Loading...</p>';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(showQv)
      .catch(function () { qbody.innerHTML = '<p class="qv__load">Could not load this product.</p>'; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-qv]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    openQv(b.getAttribute('data-qv'), b);
  }, true);

  /* ---------- recently viewed ---------- */
  var KEY = 'mm-recent';
  function getRecent() { try { var a = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function setRecent(a) { try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  var m = location.pathname.match(/\/products\/([^\/?#]+)/);
  var cur = null;
  try { cur = m ? decodeURIComponent(m[1]) : null; } catch (e) {}
  var cls = document.body.className;
  if (cur && /template-product/.test(cls)) {
    var list0 = getRecent().filter(function (h) { return h !== cur; });
    list0.unshift(cur);
    setRecent(list0.slice(0, 12));
  }
  var rv = document.querySelector('[data-rv]');
  if (rv && /template-(product|cart)/.test(cls)) {
    var handles = getRecent().filter(function (h) { return h !== cur; }).slice(0, 8);
    if (handles.length) {
      Promise.all(handles.map(function (h) {
        return fetch(root + 'products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (parts) {
        var out = parts.filter(function (x) { return x && x.trim(); }).join('');
        if (!out) return;
        rv.querySelector('[data-rv-row]').innerHTML = out;
        rv.hidden = false;
      });
    }
  }
})();